import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, StatusComponent, SelectComponent } from "../../../common/component/Index";
import CustomPrice from './../../../../../models/CustomPrice';
import { PATHS, DATE_TIME_FORMAT } from './../../../../../constants/Define';
import { withTranslation } from "react-i18next";
import { Icon, Rate } from 'antd';
import Ripple from '../../../common/component/Ripple';
import Modal from '../../../common/component/Modal';

class VinWonderPriceList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columns: this.getTableColumns(),
            filters: {},
        };
    }

    render() {
        const { loading, pagination, vinWonderPrices, vinWonderId } = this.props;
        const { columns } = this.state;

        return (
            <ListComponent
                tableKey="vin-wonder-price-list"
                classChildren="p-0" classParent="m-0"
                rowKey={record => record.id}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={vinWonderPrices}
                columns={Func.columnsTable({
                    titleTable: columns,
                    component: this.renderTableBody(),
                    itemName: 'vinWonderPrice'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent }}
                componentTableList={{}}
            />
        );
    }

    renderTableBody() {
        return {
            name: {
                width: 150,
                key: 'name',
                fixed: 'left',
                // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
                //     <HMS.SelectComponent
                //         optionFilterProp="children"
                //         className={`hms-form-control select-filter`}
                //         value={selectedKeys[0]}
                //         showSearch
                //         hmsData={this.props.hotels}
                //         allowClear
                //         onChange={e => {
                //             setSelectedKeys(Func.getValueForm(e).value ? [Func.getValueForm(e).value] : []);
                //             confirm();
                //         }}
                //     />
                // ),
                filterIcon: filtered => (
                    <Icon type="filter" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            type: {
                width: 100,
                key: 'type',
                align: 'center',
                render: (type) => this.props.t(`item.vinWonderPrice.${type.toLowerCase()}`)
            },
            value: {
                width: 100,
                key: 'value',
                align: 'right',
            },
            startDate: {
                width: 100,
                key: 'startDate',
                align: 'center',
                render: (startDate, record) => startDate.format && startDate.format(DATE_TIME_FORMAT.DATE_TIME),
            },
            endDate: {
                width: 100,
                key: 'endDate',
                align: 'center',
                render: (endDate, record) => endDate.format && endDate.format(DATE_TIME_FORMAT.DATE_TIME),
            },
            action: {
                width: 100,
                align: 'center',
                key: 'action',
                render: (text, record) => this.renderEditComponent(record),
            }
        }
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.price.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: () => {
                    return this.props.onDeletePrice && this.props.onDeletePrice(item)
                },
            });
        };
        return (
            <Fragment>
                {
                    permisions && permisions.allowUpdate &&
                    <Link to={Func.getPathWithParams(PATHS.VIN_WONDER_PRICE.DETAIL.path, { vin_wonder_id: this.props.vinWonderId, id: item.id })} className={`mr-2 colorPrimary`}>
                        <Ripple><Icon type="form" className="fs20" /></Ripple>
                    </Link>
                }
                {
                    permisions && permisions.allowDelete &&
                    <Ripple onClick={onRemove}><Icon type="delete" className="fs20 colorPrimary" /></Ripple>
                }
            </Fragment>
        )
    }

    getTableColumns() {
        const PriceObj = new CustomPrice({});
        return Func.getTitleTable(['name', 'type', 'value', 'startDate', 'endDate'], ['action'], ['id', 'hotel']);
    }


}

export default withTranslation()(VinWonderPriceList);
